module.exports = __webpack_public_path__ + "static/img/bg-id.08f4af26.png";